var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 20,
    viewBox: "0 0 36 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 11.6668C17.558 11.6668 17.134 11.4912 16.8215 11.1787C16.5089 10.8661 16.3333 10.4422 16.3333 10.0002C16.3333 9.55814 16.5089 9.13421 16.8215 8.82165C17.134 8.50909 17.558 8.3335 18 8.3335C18.442 8.3335 18.866 8.50909 19.1785 8.82165C19.4911 9.13421 19.6667 9.55814 19.6667 10.0002C19.6667 10.4422 19.4911 10.8661 19.1785 11.1787C18.866 11.4912 18.442 11.6668 18 11.6668ZM12.1667 11.6668C11.7246 11.6668 11.3007 11.4912 10.9882 11.1787C10.6756 10.8661 10.5 10.4422 10.5 10.0002C10.5 9.55814 10.6756 9.13421 10.9882 8.82165C11.3007 8.50909 11.7246 8.3335 12.1667 8.3335C12.6087 8.3335 13.0326 8.50909 13.3452 8.82165C13.6577 9.13421 13.8333 9.55814 13.8333 10.0002C13.8333 10.4422 13.6577 10.8661 13.3452 11.1787C13.0326 11.4912 12.6087 11.6668 12.1667 11.6668ZM23.8333 11.6668C23.3913 11.6668 22.9674 11.4912 22.6548 11.1787C22.3423 10.8661 22.1667 10.4422 22.1667 10.0002C22.1667 9.55814 22.3423 9.13421 22.6548 8.82165C22.9674 8.50909 23.3913 8.3335 23.8333 8.3335C24.2754 8.3335 24.6993 8.50909 25.0118 8.82165C25.3244 9.13421 25.5 9.55814 25.5 10.0002C25.5 10.4422 25.3244 10.8661 25.0118 11.1787C24.6993 11.4912 24.2754 11.6668 23.8333 11.6668Z",
    fill: "#00067E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOption);
export default __webpack_public_path__ + "static/media/option.0f068f56bce2e3e9b9f8cb32175d9843.svg";
export { ForwardRef as ReactComponent };